import { render, staticRenderFns } from "./paperPromotion.vue?vue&type=template&id=1f97de3a&scoped=true"
import script from "./paperPromotion.vue?vue&type=script&lang=js"
export * from "./paperPromotion.vue?vue&type=script&lang=js"
import style0 from "./paperPromotion.vue?vue&type=style&index=0&id=1f97de3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f97de3a",
  null
  
)

export default component.exports